/**
 * Properties: UI strings for the property details page (views/properties/single/Index.vue).
 *
 * Structure: single top-level `properties` namespace, grouped by details-page section.
 * Keep values in the same order in the En and Fr objects.
 */

export const propertiesEn = {
  properties: {
    pets: {
      petTypesBanner: 'Some listing sites only use Pets Allowed (Yes/No), while others also use Pet Types. '
        + 'If Pets Allowed is Yes and no Pet Types are selected, some listing sites may interpret this as all pets being allowed.',
      defaultDepositLabel: 'Default pet deposit',
      defaultDepositHelp: 'Applies to every selected pet type unless a type sets its own deposit below.',
      typeDepositLabel: '{type} deposit',
      typeDepositPlaceholderInherit: 'Default: {amount}',
      typeDepositPlaceholderOptional: 'Optional',
      typeDepositDisabled: 'Check {type} to set a deposit.',
      overridePill: 'Override',
      // Caption under each pet type deposit, keyed by TPetDepositState.
      depositState: {
        none: 'No deposit set.',
        inherits: 'Uses the {amount} default pet deposit.',
        overrides: 'Replaces the {amount} default pet deposit on some listing sites and websites.',
        same: 'Same as the default pet deposit. Clear this field to keep them in sync.',
        solo: 'Shown on some listing sites and websites. Others have no pet deposit to show.',
      },
    },
    smoking: {
      sectionLabel: 'Smoking',
      allowedLabel: 'Smoking Allowed?',
      designatedOnlyLabel: 'Designated areas only',
      designatedOnlyHelp: 'Smoking is permitted only in specific areas of the property, such as a balcony or an outdoor space.',
    },
  },
};

export const propertiesFr = {
  properties: {
    pets: {
      petTypesBanner: 'Certains sites d\'annonces utilisent uniquement Animaux acceptés (Oui/Non), tandis que d\'autres utilisent aussi les Types d\'animaux. '
        + 'Si Animaux acceptés est à Oui et qu\'aucun Type d\'animal n\'est sélectionné, certains sites d\'annonces peuvent l\'interpréter comme si tous les animaux étaient acceptés.',
      defaultDepositLabel: 'Dépôt pour animaux par défaut',
      defaultDepositHelp: 'S\'applique à chaque type d\'animal sélectionné, sauf si un type définit son propre dépôt ci-dessous.',
      typeDepositLabel: 'Dépôt – {type}',
      typeDepositPlaceholderInherit: 'Par défaut : {amount}',
      typeDepositPlaceholderOptional: 'Facultatif',
      typeDepositDisabled: 'Cochez {type} pour définir un dépôt.',
      overridePill: 'Remplace',
      depositState: {
        none: 'Aucun dépôt défini.',
        inherits: 'Utilise le dépôt pour animaux par défaut de {amount}.',
        overrides: 'Remplace le dépôt pour animaux par défaut de {amount} sur certains sites d\'annonces et sites web.',
        same: 'Identique au dépôt par défaut. Videz ce champ pour les garder synchronisés.',
        solo: 'Affiché sur certains sites d\'annonces et sites web. Les autres n\'ont aucun dépôt à afficher.',
      },
    },
    smoking: {
      sectionLabel: 'Tabac',
      allowedLabel: 'Tabac autorisé ?',
      designatedOnlyLabel: 'Zones désignées seulement',
      designatedOnlyHelp: 'Il est permis de fumer uniquement dans certaines zones de la propriété, comme un balcon ou un espace extérieur.',
    },
  },
};
